import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/Blogs1.jpg";

const Blog2 = () => {
  return (
    <div className="home-page">
      <Hero
        title="Blogs"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content" style={{ gap: "25px" }}>
          <div className="content-semibold grey align-left">
            What Are the Costs When Buying a House? Understanding the Hidden
            Expenses
          </div>
          <div className="content burgandy">Apr 23, 2025</div>
          <div className="divider burgandy" />

          <div className="content grey align-left">
            When you’re planning to buy a home, it’s easy to focus on the price
            of the property itself. However, there are numerous additional costs
            involved that can catch you by surprise if you’re not prepared. From
            solicitors’ fees and stamp duty to home surveys and removals,
            understanding these hidden costs is essential to budgeting
            effectively for your home purchase.
          </div>
          <div className="content grey align-left">
            <strong>
              Your home may be repossessed if you do not keep up repayments on
              your mortgage
            </strong>
          </div>
          <div className="content grey align-left">
            Information correct as of 23 April 2025
          </div>
          <div className="content grey align-left">
            <strong>Disclaimer:</strong> This blog post provides general
            information and should not be construed as financial advice. For
            personalised guidance, please consult with a qualified financial
            advisor.
          </div>
          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}
          >
            We’re here to guide you
            <div
              style={{
                borderBottom: "3px solid var(--burgandy)",
                width: "100%",
                margin: "10px 0",
              }}
            ></div>
          </div>
          <div className="content grey align-left">
            At <strong>WPP Financial Services</strong>, we’re here to guide you
            through the entire home-buying process, helping you prepare for all
            financial aspects, not just the deposit. Let’s break down the key
            costs you’ll need to account for when buying a home.
          </div>
          <div
            className="content grey align-left"
            style={{ color: "var(--burgandy)", marginTop: "2rem" }}
          >
            7 Key Costs to Consider
          </div>
          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "2rem", marginTop: "0.5rem" }}
          >
            When Buying a Home
          </div>
          <div
            className="content grey align-left"
            style={{ marginTop: "1.5rem" }}
          >
            <strong>1: Stamp Duty</strong>
            <ul>
              <li>
                Stamp duty is one of the most significant expenses for
                homebuyers. For first-time buyers in England and Northern
                Ireland, there’s no stamp duty on homes up to £300,000. For
                properties above this, a 5% rate applies. Existing homeowners
                will pay different rates based on the property’s price, with
                rates starting at 2% for properties over £125,000.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>2: Solicitors Fees (Conveyancing)</strong>
            <ul>
              <li>
                Conveyancing fees cover the legal work involved in transferring
                property ownership. This typically costs between £400 to £1,500,
                plus disbursements. Fees can be higher for leasehold properties,
                and they vary depending on your location.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>3: House Removals</strong>
            <ul>
              <li>
                The cost of moving home can also add up, with the average
                removals service costing around £1,300 for a one- to two-bedroom
                house. The cost increases for larger homes, and whether you
                choose a full-service move or handle some tasks yourself will
                influence the total.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>4: Mortgage Arrangement Fees</strong>
            <ul>
              <li>
                Many mortgage deals come with arrangement fees, often up to
                £2,000. While you can usually add these fees to your mortgage,
                this means paying more interest over time.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>5: Home Surveys</strong>
            <ul>
              <li>
                A survey is essential to ensure the property is worth the
                investment and free from hidden issues. Prices vary depending on
                the type of survey, with a basic RICS Level 1 survey starting at
                £300 and comprehensive surveys costing up to £1,200.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>6: Estate Agent Fees (For Sellers)</strong>
            <ul>
              <li>
                If you’re selling your current home, estate agent fees are
                another important cost to consider. This typically ranges
                between 1% to 3% of the sale price of your property.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            <strong>7: Other Costs to Consider</strong>
            <ul>
              <li>
                You may also incur other costs such as a home insurance policy,
                valuation fees from your mortgage provider, and potentially a
                booking fee to secure your mortgage.
              </li>
            </ul>
          </div>
          <div
            className="content grey align-left"
            style={{ marginTop: "2rem" }}
          >
            By understanding all these costs, you can plan your budget more
            effectively and avoid any surprises. It’s essential to work with a
            mortgage advisor to ensure you’re financially prepared for all these
            expenses. If you’re ready to take the next step in your home-buying
            journey, <strong>contact us at WPP Financial Services</strong> for
            expert advice and support every step of the way!
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default Blog2;
